interface MediaImageLogo {
  alt: string;
  href: string;
  name: string;
  src: string;
}

export const mediaImages: MediaImageLogo[] = [
  {
    alt: 'Fast Company logo',
    href: '//www.fastcompany.com/40565814/this-startup-wants-to-help-you-use-facebook-to-find-a-mentor',
    name: 'fastcompany',
    src: '//storage.googleapis.com/ttc-static-images/landing/fastcompany-logo.36b07fa7.svg',
  },
  {
    alt: 'Forbes logo',
    href: '//www.forbes.com/sites/pauleannareid/2017/11/15/this-mentorship-platform-connects-young-professionals-to-ceos-in-more-than-40-industries',
    name: 'forbes',
    src: '//storage.googleapis.com/ttc-static-images/landing/forbes-logo.76998a9.svg',
  },
  {
    alt: 'American Banker logo',
    href: '//www.americanbanker.com/news/rbcs-software-solution-to-matching-millennial-employees-with-mentors',
    name: 'americanbanker',
    src: '//storage.googleapis.com/ttc-static-images/landing/americanbanker.8240f0ad.svg',
  },
  {
    alt: 'Globe and Mail logo',
    href: '//www.theglobeandmail.com/business/careers/business-education/article-networking-skills-brew-over-a-cup-of-coffee',
    name: 'globeandmail',
    src: '//storage.googleapis.com/ttc-static-images/landing/globeandmail-logo.e0e97df.svg',
  },
  {
    alt: 'Distrupt HR logo',
    href: '//disrupthr.co/vimeo-video/learn-how-to-un-mentor-dave-wilkin-disrupthr-talks',
    name: 'disrupthr',
    src: '//storage.googleapis.com/ttc-static-images/distruphr.a0910773.svg',
  },
];
